import { STATIC_PAGE_REGISTRY } from '@/components/CustomTheme/utils/builder-registry';
import { apiContactPage, apiFooterPagesData } from '@/apis/user';

// Mirrors the builder's Canvas.tsx fetch effect, but for server-rendered pages (the
// preview route and the live published site) - both need the same per-page data for
// the standard static pages (About Us, Contact Us, etc.), since it isn't tied to any
// single section/component the way every other page's data is.
export async function resolveStaticPageData(pageId: string | undefined, domain: string | undefined): Promise<any | null> {
    if (!pageId || !domain) return null;

    const info = STATIC_PAGE_REGISTRY[pageId];
    if (!info) return null;

    try {
        const response = info.isContactPage
            ? await apiContactPage(domain)
            : await apiFooterPagesData(domain, info.slug);
        return response?.data ?? null;
    } catch (err) {
        console.error('[API Error] Static page data:', err);
        return null;
    }
}

// Looks up a single placeholder (page_name/page_description/phone_no/email/address/
// details) in the fetched static page data. The contact page's fields live nested
// under CompanyContactUs, the other static pages are flat on the response.
export const resolveStaticPageValue = (key: string | undefined, staticPageData: any): any => {
    if (!key || !staticPageData) return undefined;
    const contactInfo = staticPageData.CompanyContactUs;
    if (contactInfo && contactInfo[key] !== undefined && contactInfo[key] !== null) {
        return contactInfo[key];
    }
    if (staticPageData[key] !== undefined && staticPageData[key] !== null) {
        return staticPageData[key];
    }
    return undefined;
};
